import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class CommodityCodeReferenceService extends BaseReferenceService {
  constructor() {
    super('CommodityCodeReference');
  }
}
